import type { Country, Destination, Hotel, Resort } from '@/shared/model';

export function destinationEntity(item: Destination): Country | Resort | Hotel {
  switch (item.type) {
    case 'country': {
      return item.country;
    }
    case 'resort': {
      return item.resort;
    }
    case 'hotel': {
      return item.hotel;
    }
  }
}
